import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20scholarly%20library%20interior%20with%20sunlight%20streaming%20through%20tall%20windows%2C%20wooden%20bookshelves%20filled%20with%20books%2C%20green%20plants%2C%20peaceful%20and%20inspiring%20atmosphere%2C%20soft%20beige%20and%20warm%20golden%20tones%2C%20minimalist%20composition%2C%20high%20quality%20editorial%20photography&width=1800&height=700&seq=hero-bg-2026&orientation=landscape"
        alt="含羞草研究院知识探索平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>

      <div className="relative z-10 w-full container-page text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          探索知识的无限可能
        </h1>
        <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          含羞草研究院致力于为每一位求知者提供有深度的研究内容、实用的学习方法和丰富的成长资源，帮助你在知识的海洋中找到属于自己的航向。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/learning-methods"
            className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-md font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="bg-white/15 hover:bg-white/25 text-white border border-white/30 px-8 py-3 rounded-md font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}

export function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            探索知识领域
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            六大核心领域，系统化构建你的知识体系，从认知科学到效率提升，总有一个方向适合你。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-primary-600 text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-foreground-400">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturedArticles() {
  const featuredArticles = [
    {
      id: 'art-001',
      title: '深度工作：如何在碎片化时代重建专注力',
      slug: 'deep-work-rebuild-focus',
      category: 'productivity',
      categoryName: '效率提升',
      author: '林教授',
      date: '2026-07-15',
      readTime: '12分钟',
      excerpt: '在信息爆炸的时代，深度工作能力已成为最稀缺的认知资源。本文从神经科学角度出发，探讨如何通过刻意训练重建深度专注力。',
      image: 'https://readdy.ai/api/search-image?query=Calm%20minimalist%20workspace%20with%20warm%20wooden%20desk%20and%20soft%20natural%20light%2C%20open%20notebook%20and%20pen%2C%20plant%20on%20desk%2C%20scholarly%20atmosphere%2C%20clean%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=feat-art-001&orientation=landscape',
    },
    {
      id: 'art-003',
      title: '费曼学习法：用最简单的语言掌握最复杂的概念',
      slug: 'feynman-technique-mastery',
      category: 'learning-methods',
      categoryName: '学习方法',
      author: '陈导师',
      date: '2026-07-08',
      readTime: '10分钟',
      excerpt: '通过教会别人来学会知识，这种以教代学的方法能帮你真正理解任何复杂概念。',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20chalkboard%20with%20elegant%20handwritten%20diagrams%2C%20warm%20natural%20light%2C%20scholarly%20atmosphere%2C%20minimalist%20style&width=800&height=500&seq=feat-art-003&orientation=landscape',
    },
    {
      id: 'art-002',
      title: '认知偏见手册：识别并克服常见的思维陷阱',
      slug: 'cognitive-bias-handbook',
      category: 'critical-thinking',
      categoryName: '批判性思维',
      author: '王博士',
      date: '2026-07-10',
      readTime: '15分钟',
      excerpt: '系统梳理十余种常见的认知偏见，结合心理学研究成果，提供实用策略帮你识别和克服思维陷阱。',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20brain%20illustration%20with%20warm%20tones%2C%20light%20and%20shadow%20contrast%2C%20clean%20minimalist%20style%2C%20conceptual%20design&width=800&height=500&seq=feat-art-002&orientation=landscape',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-page">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              编辑团队精心挑选的深度好文
            </p>
          </div>
          <Link
            to="/category/learning-methods"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 bg-primary-500 text-white text-xs px-2.5 py-1 rounded-md whitespace-nowrap">
                  {article.categoryName}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>{article.date} · {article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FeaturesSection() {
  const features = [
    {
      icon: 'ri-book-read-line',
      title: '深度研究内容',
      description: '由领域专家撰写，每篇文章都经过严格的内容审核和学术把关，确保信息的准确性和深度。',
    },
    {
      icon: 'ri-user-star-line',
      title: '权威导师团队',
      description: '汇聚来自顶尖高校和研究机构的学者与实践者，为你带来最前沿的知识与洞察。',
    },
    {
      icon: 'ri-community-line',
      title: '活跃学习社区',
      description: '与志同道合的求知者一起探讨、交流和成长，在思想碰撞中激发新的灵感。',
    },
    {
      icon: 'ri-tools-line',
      title: '实用工具方法',
      description: '提供可直接应用的思维模型、学习框架和效率工具，将理论知识转化为实践能力。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            为什么选择含羞草研究院
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            我们致力于打造最专业的知识探索与学习成长平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feat, i) => (
            <div key={i} className="text-center p-5 md:p-6">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-100/80 rounded-full mx-auto mb-4">
                <i className={`${feat.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  const faqs = [
    {
      q: '含羞草研究院适合什么样的人群？',
      a: '含羞草研究院适合所有渴望知识探索和自我提升的人，无论你是学生、职场人士还是终身学习者，这里都有适合你的内容和资源。',
    },
    {
      q: '平台上的内容是否免费？',
      a: '我们提供大量优质免费内容，包括文章、方法论和学习指南。部分深度课程和专题研究可能需要订阅或单独购买，我们会在相应页面明确标注。',
    },
    {
      q: '如何选择适合自己的学习内容？',
      a: '你可以通过首页的分类导航浏览不同领域的内容，也可以使用搜索功能查找特定主题。我们建议从你最感兴趣的领域开始，逐渐拓展到其他方向。',
    },
    {
      q: '文章内容的权威性如何保证？',
      a: '所有内容均由领域内具有专业背景的作者撰写，经过编辑团队的多轮审核。我们注重引用可靠的学术来源和实践案例，确保内容的准确性和实用性。',
    },
    {
      q: '我可以投稿或成为平台作者吗？',
      a: '我们欢迎有专业知识和独特见解的作者加入。你可以通过关于我们页面的联系方式提交你的写作样本和研究方向，编辑团队会在一周内回复。',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-page">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            你可能想了解的一些问题
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-lg border border-background-200/60">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer font-medium text-foreground-900 text-sm md:text-base">
                {faq.q}
                <div className="w-5 h-5 flex items-center justify-center ml-2 flex-shrink-0">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:hidden"></i>
                  <i className="ri-arrow-up-s-line text-foreground-500 hidden group-open:block"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20with%20soft%20geometric%20shapes%2C%20golden%20and%20green%20tones%2C%20inspiring%20and%20peaceful%20atmosphere%2C%20minimalist%20background%2C%20soft%20texture&width=1800&height=500&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-primary-900/80"></div>

      <div className="relative z-10 container-page text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-4">
          准备好开始你的知识探索之旅了吗？
        </h2>
        <p className="text-white/75 text-sm md:text-base max-w-lg mx-auto mb-8">
          加入含羞草研究院，与千万求知者一起，探索知识的无限可能，开启全新的认知旅程。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/cognitive-science"
            className="bg-accent-500 hover:bg-accent-600 text-foreground-950 px-8 py-3 rounded-md font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            立即开始
          </Link>
          <Link
            to="/about"
            className="text-white/80 hover:text-white border border-white/30 px-8 py-3 rounded-md font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}